<template>
    <div class="restrictions">
        <form class="main-form" @submit.prevent="addRestriction">
            <custom-select 
                :title="$t('WEBSHOPS__GAME_TYPES')"
                :options="gameTypesOptions"
                :isRequired=true
                @clear="gameType = ''"
                v-model="gameType"
            />
            <button class="btn">{{$t('WEBSHOPS__ADD')}}</button>
        </form>
        <grid 
            identificator="gameTypeId"
            :fullGrid="true"
            :passedData="restrictedGameTypes"
            :title="$t('WEBSHOPS__RESTRICTED_GAME_TYPES')"
            :columns="columns"
            :pagination=false
            @trClicked="trClickHandler"
        />
    </div>
</template>

<script>
import CustomSelect from '@/components/ReusableComponents/CustomSelect/CustomSelect.vue'
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import axios from '@/Helpers/AxiosInstance.js'
import { getDateString } from '@/Helpers/HelperFunctions.js'
export default {
    components: {
        CustomSelect, Grid,
    },
    created() {
        this.getRestrictedGameTypes()
    },
    props: {
        webshopID: Number,
    },
    data() {
        return {
            gameType: '',
            restrictedGameTypes: [],
            gameTypes: {
                1: 'Sport',
                2: 'Live Sport',
                3: 'XLive',
                4: 'Casino',
                5: 'Live Casino',
                6: 'Virtual Sport',
            },
        }
    },
    computed: {
        gameTypesOptions() {
            var options = [
                {
                    title: this.$t('WEBSHOPS__GAME_TYPES'),
                    value: '',
                }
            ]
            Object.keys(this.gameTypes)
                    .filter(key => {
                        if(this.restrictedGameTypes.filter(el => el.gameTypeId == key).length > 0) return false
                        return true
                    })
                    .map(key => {
                        options.push({title: this.gameTypes[key], value: key})
                    })
            return options
        },
        columns() {
            return [
                {
                    title: this.$t('WEBSHOPS__GAME_TYPE'),
                    key: 'gameTypeId',
                    customTemplate: (item, val) => this.gameTypes[val]
                },
                {
                    title: this.$t('WEBSHOPS__CREATE_DATE'),
                    key: 'createDate',
                    customTemplate: (item, val) => getDateString(val, 'yyyy-MM-dd HH:mm'),
                },
                {
                    title: '',
                    key: '',
                    customTemplate: () => `<i class="material-icons delete">delete_forever</i>`
                }
            ]
        }
    },
    methods: {
        getRestrictedGameTypes() {
            axios
                .get('WebShop/GetWebShopRestrictedGameTypes', {params: {webShopId: this.webshopID}})
                .then(resp => this.restrictedGameTypes = resp.data.response)
        },
        addRestriction() {
            axios
                .post('WebShop/CreateWebShopGameTypeRestriction', {
                    webShopId: this.webshopID,
                    gameTypeId: this.gameType,
                })
                .then(resp => {
                    if(resp.data.status != 1) return
                    this.gameType = ''
                    this.getRestrictedGameTypes()
                })
        },
        trClickHandler(elem, e) {
            if(!e.target.matches('.delete')) return
            axios
                .delete('WebShop/DeleteWebShopGameTypeRestriction', {data: { webShopId: this.webshopID, gameTypeId:elem.gameTypeId }})
                .then(resp => {
                    if(resp.data.status != 1) return
                    this.getRestrictedGameTypes()
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.restrictions {
    margin-top: 3.75rem;

    .main-form {
        display: flex;
    }

    /deep/ .grid {
        margin-top: 15 * $rem;
    }

    /deep/ .delete {
        cursor: pointer;
        color: $red;
    }
}
</style>>